import React, { FC } from 'react';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiTypography from '@mui/material/Typography';
import { VirtualVisitCareCard } from '.';
import { logEvent } from '../../analytics';
import { ClinicHours, ClinicInfo } from '../../types';
import {
    formatDayTimeRange,
    subtractMinutesFromDate,
} from '../../utils/dateTime';
import styles from './AccordionCareCard.module.css';

export const AccordionCareCard: FC<{
    clinicInfo: ClinicInfo;
    disableAccordion?: boolean;
    expanded: any;
    summaryContent: any;
}> = ({ clinicInfo, disableAccordion, expanded, summaryContent }) => {
    const createDayTimeRangeElement = (openDays: ClinicHours[]) => {
        const formattedDayTimeRange = formatDayTimeRange(openDays);

        const timeRange = formattedDayTimeRange.map((currentDayTime) => (
            <p>
                {currentDayTime.timeRange.startTime +
                    ' - ' +
                    currentDayTime.timeRange.endTime +
                    ' ' +
                    currentDayTime.day.startDay}
                {currentDayTime.day.endDay
                    ? ' - ' + currentDayTime.day.endDay
                    : null}
            </p>
        ));
        return (
            <span className={styles.accordionHourContainer}>
                <p className={styles.accordionHourTitle}>Hours</p>
                {timeRange}
            </span>
        );
    };

    const content =
        clinicInfo.clinicType === 'Virtual' ? (
            <AccordionDetails className={styles.accordionDetails}>
                <div>
                    <VirtualVisitCareCard template={clinicInfo.template} />
                </div>
            </AccordionDetails>
        ) : (
            <AccordionDetails className={styles.accordionDetails}>
                <div>
                    <>
                        <MuiTypography className={styles.accordionTitle}>
                            {clinicInfo.displayName}
                        </MuiTypography>
                        <MuiTypography className={styles.accordionBody}>
                            {clinicInfo.clinicType !== 'Virtual' &&
                                clinicInfo?.address && (
                                    <span>
                                        <span
                                            className={styles.accordionAddress}
                                        >
                                            {clinicInfo.address.line1}
                                        </span>
                                        <span
                                            className={styles.accordionAddress}
                                        >
                                            {clinicInfo.address.line2}{' '}
                                        </span>
                                        {clinicInfo.address.city && (
                                            <span
                                                className={
                                                    styles.accordionAddress
                                                }
                                            >
                                                {clinicInfo.address.city},{' '}
                                                {clinicInfo.address.state}{' '}
                                                {clinicInfo.address.postalCode}
                                            </span>
                                        )}
                                    </span>
                                )}
                            {clinicInfo?.phone && (
                                <a
                                    className={styles.accordionPhone}
                                    href={`tel:${clinicInfo.phone}`}
                                    onClick={() => {
                                        logEvent(
                                            'PC - Prov Card - Click to Call'
                                        );
                                    }}
                                >
                                    {clinicInfo.phone}
                                </a>
                            )}
                            {clinicInfo?.openDays && (
                                <span>
                                    {createDayTimeRangeElement(
                                        clinicInfo.openDays
                                    )}
                                </span>
                            )}
                            {clinicInfo?.canSchedule === false && (
                                <p className={styles.accordionHeading}>
                                    {' '}
                                    Call to schedule an appointment.
                                </p>
                            )}
                            {clinicInfo?.appointmentNotes && (
                                <p>
                                    <span className={styles.accordionHeading}>
                                        {' '}
                                        Reason for visit:{' '}
                                    </span>
                                    <span> {clinicInfo.appointmentNotes} </span>
                                </p>
                            )}
                            {clinicInfo?.appointmentDate &&
                                clinicInfo?.appointmentStartTime && (
                                    <MuiTypography
                                        className={styles.accordionBody}
                                    >
                                        <span
                                            className={styles.accordionHeading}
                                        >
                                            Please arrive at{' '}
                                        </span>
                                        {subtractMinutesFromDate(
                                            clinicInfo.appointmentDate,
                                            clinicInfo.appointmentStartTime
                                        )}
                                    </MuiTypography>
                                )}
                        </MuiTypography>
                    </>
                </div>
            </AccordionDetails>
        );

    return (
        <div className="accordionCareCardContainer">
            <MuiAccordion
                className={styles.accordionCareCard}
                expanded={expanded}
            >
                <MuiAccordionSummary
                    className={styles.accordionSummary}
                    expandIcon={disableAccordion ? null : <ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    {summaryContent}
                </MuiAccordionSummary>
                {content}
            </MuiAccordion>
        </div>
    );
};
